import type { PropsWithChildren } from "react";
import { RowSidebar } from "./RowSidebar";

interface HeaderProps {
  className?: string;
}

export const Header = ({
  children,
  className,
}: PropsWithChildren<HeaderProps>) => (
  <RowSidebar
    className={className}
    dataTestId="paywall-checkout-sidebar-header"
  >
    {children}
  </RowSidebar>
);
